import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

import AddFilled from '../../../assets/add-filled.svg';
import CloseFilled from '../../../assets/close-filled.svg';
import TARGETING_TACTICS from '../../../constants/adGroupTargeting';

interface TacticsPickerProps {
  tactics: string[];
  defaultColor?: 'default' | 'success' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';
  variant?: 'outlined' | 'filled';
}

function TacticsPicker({ tactics, defaultColor = 'default', variant = 'outlined' }: TacticsPickerProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
      {tactics.map((tactic) => (
        <Controller
          name={`targetingsEnabled.${tactic}`}
          key={tactic}
          render={({ field }) => (
            <Chip
              sx={{ margin: '0 0.5rem 0.5rem 0' }}
              variant={variant}
              color={field.value ? 'primary' : defaultColor}
              label={<Typography>{TARGETING_TACTICS[tactic]?.label}</Typography>}
              onClick={() => field.onChange(!field.value)}
              onDelete={() => field.onChange(!field.value)}
              deleteIcon={
                field.value ? (
                  <img src={CloseFilled} alt="close-filled" />
                ) : (
                  <img src={AddFilled} alt="add-filled" />
                )
              }
            />
          )}
        />
      ))}
    </Box>
  );
}

export default TacticsPicker;
